import gsap from 'gsap';
import { ease1 } from '../../easings';

const ANIMATION_SELECTORS = {
    HEADER: {
        TITLE: '.js-catalog-title',
        TAB: '.js-catalog-tab',
        BREADCRUMBS: 'a-breadcrumbs',
        BREADCRUMB: '.a-breadcrumbs__item',
        TAGS_LIST: '.js-filter-tags-list',
    },
    PRODUCTS_CONTAINER: '.js-catalog-products',
    CERTIFICATES: {
        CONTAINER: '.js-catalog-certificates',
        TITLE: '.js-catalog-certificates-title',
        DESCRIPTION: '.js-catalog-certificates-description',
        ITEM: '.js-c-certificate',
        CONTROLS: '.js-catalog-certificates-controls',
    },
};

const init = () => {
    // DIRTY HACK - через CSS не получилось сделать так, чтобы изначально не было видно...
    gsap.set(ANIMATION_SELECTORS.CERTIFICATES.DESCRIPTION, { opacity: 0 });

    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    firstViewportTimeline
        .set(ANIMATION_SELECTORS.PRODUCTS_CONTAINER, { opacity: 0 })
        .set(ANIMATION_SELECTORS.HEADER.BREADCRUMBS, { opacity: 1 })
        .set(ANIMATION_SELECTORS.HEADER.TAGS_LIST, { opacity: 1 })
        .fromTo(
            ANIMATION_SELECTORS.HEADER.TITLE,
            { yPercent: 80, opacity: 0 },
            { duration: 1.3, yPercent: 0, opacity: 1 },
        )
        .fromTo(
            ANIMATION_SELECTORS.HEADER.BREADCRUMB,
            { opacity: 0 },
            { duration: 1.4, opacity: 1, delay: -0.8, stagger: 0.17 },
        )
        .fromTo(
            ANIMATION_SELECTORS.HEADER.TAB,
            { opacity: 0 },
            { duration: 1.4, opacity: 1, delay: -0.8, stagger: 0.17 },
        )
        .to(ANIMATION_SELECTORS.PRODUCTS_CONTAINER, { duration: 1.5, opacity: 1, delay: -1.3 });

    const certificatesTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ANIMATION_SELECTORS.CERTIFICATES.CONTAINER,
            start: 'top bottom-=30%',
        },
        defaults: { duration: 1, ease: ease1 },
    });

    certificatesTimeline
        .set(ANIMATION_SELECTORS.CERTIFICATES.ITEM, { opacity: 0, x: '30vw' })
        .fromTo(ANIMATION_SELECTORS.CERTIFICATES.TITLE, { yPercent: 60, opacity: 0 }, { yPercent: 0, opacity: 1 })
        .to(ANIMATION_SELECTORS.CERTIFICATES.DESCRIPTION, { opacity: 0.5, duration: 1.4, delay: -0.5 })
        .to(ANIMATION_SELECTORS.CERTIFICATES.ITEM, { opacity: 1, x: '0vw', delay: -1 })
        .fromTo(ANIMATION_SELECTORS.CERTIFICATES.CONTROLS, { opacity: 0 }, { duration: 1.4, opacity: 1, delay: -1 });
};

const _module = { init };

export default _module;
